module.exports = [
    "Academic Librarian",
    "Accountant",
    "Accounting Technician",
    "Actuary",
    "Adult Nurse",
    "Advertising Account executive",
    "Advertising Account planner",
    "Advertising Copywriter",
    "Advice Worker",
    "Aeronautical Engineer",
    "Agricultural Consultant",
    "Agricultural Manager",
    "Aid Worker/Humanitarian Worker",
    "Air Traffic Controller",
    "Airline Cabin Crew",
    "Amenity Horticulturist",
    "Analytical Chemist",
    "Animal Nutritionist",
    "Animator",
    "Archaeologist",
    "Architect",
    "Architectural Technologist",
    "Archivist",
    "Armed Forces Officer",
    "AromaTherapist",
    "Art Therapist",
    "Arts Administrator",
    "Auditor",
    "Automotive Engineer",
    "Barrister",
    "Barrister's Clerk",
    "Bid Manager",
    "Bilingual Secretary",
    "Biomedical Engineer",
    "Biomedical Scientist",
    "Biotechnologist",
    "Border Force Officer",
    "Brand Manager",
    "Broadcasting Presenter",
    "Building Control Officer/Surveyor",
    "Building Services Engineer",
    "Building Surveyor",
    "Business Analyst",
    "Camera Operator",
    "Careers Adviser (Higher Education)",
    "Careers Adviser",
    "Careers Consultant",
    "Cartographer",
    "Catering Manager",
    "Charities Administrator",
    "Charities Fundraiser",
    "Chemical (Process) Engineer",
    "Child PsychoTherapist",
    "Children's Nurse",
    "Chiropractor",
    "Civil Engineer",
    "Civil Service Administrator",
    "Clinical Biochemist",
    "Clinical Cytogeneticist",
    "Clinical Microbiologist",
    "Clinical Molecular Geneticist",
    "Clinical Research Associate",
    "Clinical Scientist",
    "Clothing Technologist",
    "Colour Technologist",
    "Commercial Airline Pilot",
    "Commercial Horticulturist",
    "Commercial/Residential Surveyor",
    "Commissioning Editor",
    "Commissioning Engineer",
    "Commodity Broker",
    "Communications Engineer",
    "Community Arts Worker",
    "Community Education Officer",
    "Community Worker",
    "Company Secretary",
    "Computer Sales Support",
    "Computer Scientist",
    "Conference Organiser",
    "Consultant",
    "Consumer Rights Adviser",
    "Control and Instrumentation Engineer",
    "Corporate Banker",
    "Corporate Treasurer",
    "Counsellor",
    "Court Reporter/Verbatim Reporter",
    "Credit Analyst",
    "Crown Prosecution Service lawyer",
    "Crystallographer",
    "Curator",
    "Customs Officer",
    "Cyber Security Specialist",
    "Dance Movement PsychoTherapist",
    "Data Analyst",
    "Data Scientist",
    "Data Visualisation Analyst",
    "Database Administrator",
    "Debt/Dinance Adviser",
    "Dental Hygienist",
    "Dentist",
    "Design Engineer",
    "Design Manager (Construction)",
    "DevOps Engineer",
    "Dietitian",
    "Diplomatic Service",
    "Doctor (GP)",
    "Doctor (Hospital)",
    "DramaTherapist",
    "Economist",
    "Editorial Assistant",
    "Education Administrator",
    "Electrical Engineer",
    "Electronics Engineer",
    "Employment Advice Worker",
    "Energy Conservation Officer",
    "Energy Consultant",
    "Engineering Geologist",
    "Environmental Education Officer",
    "Environmental Health Officer",
    "Environmental Manager",
    "Environmental Scientist",
    "Equal Opportunities Officer",
    "Equality and Diversity Officer",
    "Ergonomist",
    "Estate Agent",
    "Estimator",
    "European Commission Administrators",
    "Exhibition Display Designer",
    "Exhibition Organiser",
    "Exploration Geologist",
    "Facilities Manager",
    "Field Trials Officer",
    "Financial Manager",
    "Fire Engineer",
    "Firefighter",
    "Fisheries Enforcement Officer",
    "Fitness Centre Manager",
    "Food Scientist",
    "Food Technologist",
    "Forensic Scientist",
    "Freight Forwarder",
    "Geneticist",
    "Geographical Information Systems Manager",
    "Geomatics/Land Surveyor",
    "Government Lawyer",
    "Government Research Officer",
    "Graphic Designer",
    "Health and Safety Adviser",
    "Health and Safety Inspector",
    "Health Promotion Specialist",
    "Health Service Manager",
    "Health Visitor",
    "Herbalist",
    "Heritage Manager",
    "Higher Education Administrator",
    "Higher Education Advice Worker",
    "Homeless Support Worker",
    "Horticultural Consultant",
    "Hotel Manager",
    "Housing Adviser",
    "Human Resources Officer",
    "Hydrologist",
    "Illustrator",
    "Immigration Officer",
    "Immunologist",
    "Industrial/Product Designer",
    "Information Scientist",
    "Information Systems Manager",
    "Information Technology/Software Trainers",
    "Insurance Broker",
    "Insurance Claims Inspector",
    "Insurance Risk Surveyor",
    "Insurance Underwriter",
    "Interpreter",
    "Investment Analyst",
    "Investment Banker - Corporate Finance",
    "Investment Banker - Operations",
    "Investment FUnd Manager",
    "IT Consultant",
    "IT Support Analyst",
    "Journalist",
    "Laboratory Technician",
    "Land-based Engineer",
    "Landscape Architect",
    "Learning Disability Nurse",
    "Learning Mentor",
    "Lecturer (Adult Education)",
    "Lecturer (Further Education)",
    "Lecturer (Higher Education)",
    "Legal Executive",
    "Leisure Centre Manager",
    "Licensed Conveyancer",
    "Local Government administrator",
    "Local Government lawyer",
    "Logistics/Distribution Manager",
    "Magazine Features Editor",
    "Magazine Journalist",
    "Maintenance Engineer",
    "Management accountant",
    "Manufacturing Engineer",
    "Manufacturing Machine Operator",
    "Manufacturing Toolmaker",
    "Marine Scientist",
    "Market Research Analyst",
    "Market Research Executive",
    "Marketing Assistant",
    "Marketing Executive",
    "Marketing Manager (Direct)",
    "Marketing Manager (Social Media)",
    "Materials Engineer",
    "Materials Specialist",
    "Mechanical Engineer",
    "Media Analyst",
    "Media Buyer",
    "Media Planner",
    "Medical Physicist",
    "Medical Representative",
    "Mental Health Nurse",
    "Metallurgist",
    "Meteorologist",
    "Microbiologist",
    "Midwife",
    "Mining Engineer",
    "Mobile Developer",
    "Multimedia Programmer",
    "Multimedia Specialists",
    "Museum Education Officer",
    "Museum/Gallery Exhibition Officer",
    "Music Therapist",
    "Nanoscientist",
    "Nature Conservation Officer",
    "Naval Architect",
    "Network Administrator",
    "Nurse",
    "Nutritional Therapist",
    "Nutritionist",
    "Occupational Therapist",
    "Oceanographer",
    "Office Manager",
    "Operational Researcher",
    "Orthoptist",
    "Outdoor Pursuits Manager",
    "Packaging Technologist",
    "Paramedic",
    "Patent Attorney",
    "Patent Examiner",
    "Pension Scheme Manager",
    "Personal Assistant",
    "Petroleum Engineer",
    "Pharmacist",
    "Pharmacologist",
    "Pharmacovigilance Officer",
    "Photographer",
    "PhysioTherapist",
    "Picture Researcher",
    "Planning and Development Surveyor",
    "Planning Technician",
    "Plant Breeder",
    "Police Officer",
    "Political Party Agent",
    "Political Researcher",
    "Practice nurse",
    "Press Photographer",
    "Press Sub-editor",
    "Prison Officer",
    "Private Music Teacher",
    "Probation Officer",
    "Product Development Scientist",
    "Production Manager",
    "Programme Researcher",
    "Project Manager",
    "Psychologist (Clinical)",
    "Psychologist (Educational)",
    "PsychoTherapist",
    "Public Affairs Consultant (Lobbyist)",
    "Public Affairs Consultant (Research)",
    "Public House Manager",
    "Public Librarian",
    "Public Relations (PR) Officer",
    "QA Analyst",
    "Quality Assurance Manager",
    "Quantity Surveyor",
    "Records Manager",
    "Recruitment Consultant",
    "Recycling Officer",
    "Regulatory Affairs Officer",
    "Research Chemist",
    "Research Scientist",
    "Restaurant Manager",
    "Retail Banker",
    "Retail Buyer",
    "Retail Manager",
    "Retail Merchandiser",
    "Retail Pharmacist",
    "Sales Executive",
    "Scene of Crime Officer",
    "Secretary",
    "Seismic Interpreter",
    "Site Engineer",
    "Site Manager",
    "Social Researcher",
    "Social Worker",
    "Software Developer",
    "Software Engineer",
    "Soil Scientist",
    "Solicitor",
    "Speech and Language Therapist",
    "Sports Coach",
    "Sports Development Officer",
    "Sports Therapist",
    "Statistician",
    "Stockbroker",
    "Structural Engineer",
    "Systems Analyst",
    "Systems Developer",
    "Tax Inspector",
    "Teacher (Nursery Years)",
    "Teacher (Primary)",
    "Teacher (Secondary)",
    "Teacher (Special Educational Needs)",
    "Teaching/Classroom Assistant",
    "Technical Author",
    "Technical Sales Engineer",
    "TEFL/TESL Teacher",
    "Television Production Assistant",
    "Test Automation Developer",
    "Tour Guide",
    "Tour Operator",
    "Tour/Holiday Representative",
    "Tourism Officer",
    "Tourist Information Manager",
    "Town and Country Planner",
    "Toxicologist",
    "Trade Union Official",
    "Trade Union Research Officer",
    "Trader",
    "Trading Standards Officer",
    "Training and Development Officer",
    "Translator",
    "Transportation Planner",
    "Travel Agent",
    "TV/Film/Theatre Set Designer",
    "UX Designer",
    "Validation Engineer",
    "Veterinary Nurse",
    "Veterinary Surgeon",
    "Video Game Designer",
    "Video Game Developer",
    "Volunteer Work Organiser",
    "Waste Management Officer",
    "Water Conservation Officer",
    "Water Engineer",
    "Web Designer",
    "Web Developer",
    "Welfare Rights Adviser",
    "Writer",
    "Youth Worker"
]
